<template>
  <v-dialog v-model="grillaActivo" persistent max-width="1024">
    <v-card :color="$store.state.sysBackgroundColor">
      <v-card-title>
        <v-layout row wrap>
          <v-flex>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon @click="ejecutarAccion('Cerrar')" v-on="on">
                  <v-icon>arrow_back</v-icon>
                </v-btn>
              </template>
              <span>Volver</span>
            </v-tooltip>
          </v-flex>
          <v-flex>
            <v-text-field
              ref="controlFoco"
              label="¿Texto a buscar?"
              v-model="textoBuscado"
              clearable
              @keyup.enter="ejecutarAccion('Listar')"
            ></v-text-field>
          </v-flex>
          <v-flex>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  color="primary"
                  @click="ejecutarAccion('Listar')"
                  v-on="on"
                >
                  <v-icon>search</v-icon>
                </v-btn>
              </template>
              <span>Buscar</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="columnas"
          :items="itemsDB"
          :loading="loading"
          loading-text="Cargando..."
          :items-per-page="10"
          :footer-props="{
            itemsPerPageText: 'Mostrar'
          }"
          dense
        >
          <!-- <template v-slot:header.Nombre="{ header }">
            {{ header.text.toUpperCase() }}
          </template> -->
          <template v-slot:item="{ item }">
            <tr>
              <td v-for="columna in columnas" :key="columna.value">
                <template v-if="columna.mask == undefined">{{
                  item[columna.value]
                }}</template>
                <template v-else>
                  <template v-if="columna.mask == 'esFecha'">{{
                    item[columna.value] | esFecha
                  }}</template>
                  <template v-else>
                    <template v-if="columna.mask == 'esMoneda'">{{
                      item[columna.value] | esMoneda
                    }}</template>
                  </template>
                </template>
              </td>
              <td width="100">
                <v-layout row wrap right>
                  <v-flex xs6 md6>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          x-small
                          color="primary"
                          v-if="!sinAccionEditar"
                          @click="editarItem(item)"
                          v-on="on"
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex xs6 md6>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          x-small
                          color="error"
                          v-if="!sinAccionBorrar"
                          @click="borrarItem(item)"
                          v-on="on"
                        >
                          <v-icon>delete_outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Borrar</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </td>
            </tr>
          </template>
          <template v-slot:no-data
            >-</template
          >
          <template v-slot:[`footer.page-text`]="items">
            {{ items.pageStart }} de {{ items.itemsLength }}
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "GrillaCrud",
  props: {
    activo: Boolean,
    columnas: {},
    itemsDB: {},
    loading: Boolean,
    sinAccionEditar: Boolean,
    sinAccionBorrar: Boolean
  },
  data() {
    return {
      grillaActivo: false,
      textoBuscado: ""
    };
  },
  watch: {
    activo(valor) {
      this.grillaActivo = valor;
      if (valor) {
        setTimeout(() => {
          this.$refs.controlFoco.focus();
        }, 500);
      }
    }
  },
  methods: {
    ejecutarAccion(accion) {
      this.$emit("ejecutarAccion", accion, this.textoBuscado);
    },
    editarItem(item) {
      this.$emit("editarItem", item);
    },
    borrarItem(item) {
      this.$emit("borrarItem", item);
    }
  }
};
</script>
